<!-- CreateCustomerSupportTicket.vue -->
<script lang="ts" setup>
import { computed } from 'vue';

    const ticketUrl = computed<string>(() => `/officemd/app/customersupport/ticket?${new Date().getTime()}`);
</script>

<template>
    <a :href="ticketUrl" target="customerSupportTicket">
        <slot>
            Contact Customer Support
        </slot>
    </a>
</template>